import styled from 'styled-components';
import Gauge from 'shared/components/commonComponentsMC/Gauge';
import { statCard } from 'shared/styles/theme';


const TOTAL_ENERGY_MAX = 1000;

const EnergyBanner = ({ value, unit, source = 'energy' }) => {
  const ratio =
    typeof value === 'number'
      ? Math.max(0, Math.min(1, value / TOTAL_ENERGY_MAX))
      : 0;

  return (
    <Banner>
      <Gauge
        ratio={ratio}
        icon='/images/stats-figma/stat-total-energy.png'
        alt={`total ${source} consumption`}
        size={56}
        stroke={5}
      />
      <BannerText>
        <BannerLabel>Total {source} consumption</BannerLabel>
        {value != null && (
          <BannerValue>
            {value} <BannerUnit>{unit}</BannerUnit>
          </BannerValue>
        )}
      </BannerText>
    </Banner>
  );
};

export default EnergyBanner;

const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 14px 24px;
  margin: 0 20px;
  border-radius: 16px;
  background: ${statCard.totalBg};
  border: 0.8px solid ${statCard.totalBorder};
  box-shadow: 0px 1px 1.5px rgba(0, 0, 0, 0.5);
`;

const BannerText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

const BannerLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${statCard.totalLabel};
`;

const BannerValue = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: ${statCard.totalValue};
`;

const BannerUnit = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${statCard.totalValue};
  opacity: 0.7;
`;
